import styled from "@emotion/styled";
import ViewSection from "./ViewSection";
export const ViewFooterRoot = styled(ViewSection)`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;
